<template>
    <div>
        <vx-label size="lg">Select a Campaign</vx-label>
        <div class="flex gap-2">
            <select-campaign size="lg"
                v-model="data.campaign_id"
                :flowId="props.flowId"
                :error="displayFirstError(validate.campaign_id)"></select-campaign>
            <resource-details-popover
                v-if="data.campaign_id"
                :teamId="props.teamId"
                :hover="false"
                :placement="is2Xl ? 'top' : 'left'"
                :modelValue="{ id: data.campaign_id, resource_type: 'campaign' }"
            >
                <vx-button
                    type="button"
                    size="lg"
                    color="muted-light"
                    >
                        <font-awesome-icon widthAuto :icon="faCircleInfo"></font-awesome-icon>
                </vx-button>
            </resource-details-popover>
        </div>
    </div>
</template>

<script setup>
import SelectCampaign from '~/components/general/SelectCampaign.vue';
import { VxLabel, VxButton } from '@voxie/frontend-components';
import { displayFirstError } from '~/utils/validation';
import useVuelidate from '@vuelidate/core';
import { helpers, required } from '@vuelidate/validators';
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import ResourceDetailsPopover from '~/components/general/resources/ResourceDetailsPopover.vue';
import { useMediaQuery } from '@vueuse/core';

const props = defineProps({
    flowId: String,
    teamId: {
        type: Number,
        required: true,
    },
});

const data = defineModel();
const is2Xl = useMediaQuery('(min-width: 1536px)');

const validate = useVuelidate({
    campaign_id: {
        required: helpers.withMessage('Campaign is required', required)
    }
}, data)
</script>
